import type { ReactNode } from "react";
import { Badge, type BadgeProps } from "@/components/ui/badge";

type StatusVariant = "success" | "error" | "warning";

export function statusVariant(status: string): StatusVariant {
  if (status === "completed") return "success";
  if (status === "failed") return "error";
  return "warning";
}

interface StatusBadgeProps extends Omit<BadgeProps, "variant" | "children"> {
  status: string;
  /** Override the rendered text/content (defaults to the raw status string). */
  label?: ReactNode;
}

export function StatusBadge({ status, label, ...props }: StatusBadgeProps) {
  return (
    <Badge variant={statusVariant(status)} {...props}>
      {label ?? status}
    </Badge>
  );
}
